/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootRoutes {
  ROUTE_APPLICATION = '/beneficiario/:nrSeqBeneficiario',
  ROUTE_CONFIRMAR_USUARIO = '/confirmar-usuario/:hash',
  ROUTE_INACTIVITY = '/inatividade',
  ROUTE_LOGIN = '/login',
  ROUTE_NOVA_SENHA = '/login/nova-senha/:hash',
  ROUTE_RECUPERAR_SENHA = '/login/recuperar-senha',
  ROUTE_REDIRECT = '/beneficiario',
}
export { RootRoutes };
